export default "__VITE_ASSET__DDN7wejm__"